import { supabase } from '../lib/supabase';

export const citySettingsService = {
  async getAllCitySettings() {
    const { data, error } = await supabase?.from('city_registration_settings')?.select('*')?.order('city', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getCitySettings(city) {
    const { data, error } = await supabase?.from('city_registration_settings')?.select('*')?.eq('city', city)?.single();

    if (error) throw error;
    return data;
  },

  async updateCitySettings(city, isOpen, closedMessage = null, updatedBy) {
    const { data, error } = await supabase?.from('city_registration_settings')?.upsert({
        city: city,
        is_open: isOpen,
        closed_message: closedMessage,
        updated_by: updatedBy,
        updated_at: new Date()?.toISOString()
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  async isCityOpen(city) {
    const { data, error } = await supabase?.from('city_registration_settings')?.select('is_open, closed_message')?.eq('city', city)?.single();

    if (error) throw error;
    return {
      isOpen: data?.is_open ?? true,
      message: data?.closed_message
    };
  }
};